<template>
  <li :class="`list-group-item d-flex align-items-center justify-content-between ${source.ef==10?'':'bg-gray-100'}`">
    <div class="d-flex wd-60p">
      <img :src="`${source.av}`" class="wd-30 rounded-circle mg-r-10" alt="" />
      <div :title="source.dp">
        <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">{{ source.l }}</h6>
        <span class="d-block tx-11 text-muted">{{ source.ps }}</span>
      </div>
    </div>
    <div class="text-muted mg-l-15">{{ source.un }}</div>
    <button v-if="source.ef==10"
      @click="$parent.$parent.$emit('on-action', source.id, 'remove_from_shinjeech')"
      class="btn btn-xs btn-outline-danger mg-l-auto"
    >
      Хасах
    </button>
    <button v-else-if="source.ef==-10"
      @click="$parent.$parent.$emit('on-shinjeech', source.id)"
      class="btn btn-xs btn-outline-success mg-l-auto"
    >
      томилох
    </button>
    <button v-else-if="source.ef==-50"
      class="btn btn-xs btn-danger mg-l-auto"
    >
      хасагдсан
    </button>
  </li>
</template>

<script>
export default {
  name: "item-component",
  props: {
    index: {
      // index of current item
      type: Number
    },
    source: {
      // here is: {uid: 'unique_1', text: 'abc'}
      type: Object,
      default() {
        return {};
      }
    }
  }
};
</script>
